/**
 * 客户端方法
 */
import bridge from './src/bridge' // 通信桥
import version from './src/version' // 版本比较
import closeView from './src/closeView' // 关闭web view
import newView from './src/newView' // 打开新web view
import getBackClose from './src/getBackClose' // 返回按钮
import getNotificationStatus from './src/getNotificationStatus' // 获取客户端通知是否打开
import requestBBS from './src/requestBBS' // 用社区框架打开页面
import requestNotificationSetting from './src/requestNotificationSetting' // 开启客户端通知
import requestOpenFinanceAccount from './src/requestOpenFinanceAccount' // 原生开户
import requestOpenProfitProduct from './src/requestOpenProfitProduct' // 原生散标产品详情页
import requestRefreshOpenApi from './src/requestRefreshOpenApi' // 刷新客户端首页
import requestStartOpenAccountGuide from './src/requestStartOpenAccountGuide' // 客户端开户动画
import requestUpdateWallet from './src/requestUpdateWallet' // 刷新钱包余额
import requestWalletBackToProductList from './src/requestWalletBackToProductList' // 钱包特殊跳转
import toHomePage from './src/toHomePage' // 原生理财市场
import toWallet from './src/toWallet' // 原生钱包
import requestShare from './src/requestShare' // 分享
import title from './src/title' // 设置title
import openApp from './src/openApp' // 唤醒app
import requestSecurityKeypad from './src/requestSecurityKeypad' // 唤起安全键盘
import requestCloseEye from './src/requestCloseEye' // 卡牛关闭眼睛
import requestBarStyle from './src/requestBarStyle' // 自定义导航栏
import requestClientInfo from './src/requestClientInfo' // 获取客户端信息
import openSuiguanjia from './src/openSuiguanjia' // 获取客户端信息
import requestUserInfo from './src/requestUserInfo' // 获取客户端信息

import refreshView from './src/refreshView'
import closeAllView from './src/closeAllView'
import goBackView from './src/goBackView'
import setWebViewAttribute from './src/setWebViewAttribute'
import updateOpenAccountState from './src/updateOpenAccountState'
import requestFlow from './src/requestFlow'
import requestSuiguanjiaBarStyle from './src/requestSuiguanjiaBarStyle'
import refreshWalletEntrance from './src/refreshWalletEntrance' // 刷新钱包入口

import isCanPullRefresh from './src/isCanPullRefresh' // 设置卡牛页面是否下拉刷新

export {
  bridge,
  version,
  closeView,
  newView,
  getBackClose,
  getNotificationStatus,
  requestBBS,
  requestNotificationSetting,
  requestOpenFinanceAccount,
  requestOpenProfitProduct,
  requestRefreshOpenApi,
  requestStartOpenAccountGuide,
  requestUpdateWallet,
  requestWalletBackToProductList,
  toHomePage,
  toWallet,
  requestShare,
  title,
  openApp,
  requestSecurityKeypad,
  requestCloseEye,
  requestBarStyle,
  requestClientInfo,
  refreshView,
  closeAllView,
  goBackView,
  setWebViewAttribute,
  openSuiguanjia,
  requestUserInfo,
  updateOpenAccountState,
  requestFlow,
  requestSuiguanjiaBarStyle,
  isCanPullRefresh,
  refreshWalletEntrance
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/index.js